import { render, staticRenderFns } from "./AnswerTypeRanking.vue?vue&type=template&id=56a20f5b&scoped=true"
import script from "./AnswerTypeRanking.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRanking.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRanking.vue?vue&type=style&index=0&id=56a20f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a20f5b",
  null
  
)

export default component.exports